export function normalizePhrase(phrase: string) {
  return phrase.trim().toLowerCase().replace(/\s+/g, ' ');
}

function isUpper(value: string) {
  return (
    value === value.toLocaleUpperCase() && value !== value.toLocaleLowerCase()
  );
}

export function preserveCapitalization(original: string, translated: string) {
  if (!original) {
    return translated;
  }

  if (isUpper(original)) {
    return translated.toLocaleUpperCase();
  }

  if (isUpper(original[0])) {
    return translated[0].toLocaleUpperCase() + translated.slice(1);
  }

  if (original === original.toLocaleLowerCase()) {
    return translated.toLocaleLowerCase();
  }

  return translated;
}
